import * as React from 'react'

import { Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import EmployeesList from './EmployeesList'

interface Props {
  employeeNames: string[]
  tooltipLabel: string
  description: string
}

function EmployeesTooltip({ employeeNames, tooltipLabel, description }: Props) {
  const [open, toggle] = useToggle(false)

  return (
    <Tooltip.ItemList
      title={i18n.t('documents.upload.confirmation.tooltip.title')}
      attachment="bottom center"
      open={open}
      toggle={toggle}
    >
      <Text.Normal>
        {description}{' '}
        <Text.Normal underlined dotted>
          {tooltipLabel}
        </Text.Normal>
      </Text.Normal>
      <EmployeesList employeeNames={employeeNames} />
    </Tooltip.ItemList>
  )
}

export default observer(EmployeesTooltip)
